<template>
  <v-card>
    <v-toolbar dense color="grey lighten-5" flat>
      <v-icon>mdi-pencil</v-icon>
      <v-toolbar-title class="toolbar-title-3">{{ labels.discLdgTitle }} Details </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip top v-if="enableEdit && !hideCRUD">
        <template v-slot:activator="{ on }">
          <v-btn class="mx-2" fab dark small color="primary" v-on="on" @click.native="review">
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Edit {{ labels.discLdgTitle }} Details</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <v-flex xs3 align-center justify-center d-flex
            ><h4>{{ labels.discLdgCode }}</h4></v-flex
          >
          <v-flex xs3 align-center justify-center d-flex
            ><h4>{{ labels.discLdgPct }}</h4></v-flex
          >
          <v-flex xs3 align-center justify-center d-flex
            ><h4>{{ labels.redBalDiscLdg }}</h4></v-flex
          >
          <v-flex xs3 align-center justify-center d-flex
            ><h4>{{ labels.prtDiscLdg }}</h4></v-flex
          >
          <v-flex xs3>
            <v-autocomplete
              :items="discLdgCodeList"
              v-model="mainForm.discLdg1Code"
              item-text="label"
              item-value="value"
              :loading="loading"
              @change="doDiscLdg(1)"
              clearable
              :disabled="enableEdit"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3
            ><v-text-field
              ref="discLdg1Pct"
              v-model="mainForm.discLdg1Pct"
              :label="labels.discLdg1Pct"
              :error-messages="errors.collect('discLdg1Pct')"
              data-vv-name="discLdg1Pct"
              :data-vv-as="labels.discLdg1Pct"
              v-num-mask="{ negative: true, intScale: 18, decScale: 4 }"
              v-validate="valDiscLdg1Pct"
              :disabled="enableEdit"
            ></v-text-field
          ></v-flex>
          <v-flex xs3></v-flex>
          <v-flex xs3
            ><v-autocomplete
              :items="yesnoList"
              v-model="mainForm.prtDiscLdg1"
              :label="labels.prtDiscLdg1"
              item-text="label"
              item-value="value"
              data-vv-name="prtDiscLdg1"
              :data-vv-as="labels.prtDiscLdg1"
              :error-messages="errors.collect('prtDiscLdg1')"
              :disabled="enableEdit"
            ></v-autocomplete
          ></v-flex>
          <v-flex xs3
            ><v-autocomplete
              :items="discLdgCodeList"
              v-model="mainForm.discLdg2Code"
              item-text="label"
              item-value="value"
              :loading="loading"
              @change="doDiscLdg(2)"
              clearable
              :disabled="enableEdit"
            ></v-autocomplete
          ></v-flex>
          <v-flex xs3
            ><v-text-field
              ref="discLdg2Pct"
              v-model="mainForm.discLdg2Pct"
              :label="labels.discLdg2Pct"
              :error-messages="errors.collect('discLdg2Pct')"
              data-vv-name="discLdg2Pct"
              :data-vv-as="labels.discLdg2Pct"
              v-num-mask="{ negative: true, intScale: 18, decScale: 4 }"
              v-validate="valDiscLdg2Pct"
              :disabled="enableEdit"
            ></v-text-field
          ></v-flex>
          <v-flex xs3
            ><v-autocomplete
              :items="yesnoList"
              v-model="mainForm.redBalDiscLdg2"
              :label="labels.redBalDiscLdg2"
              item-text="label"
              item-value="value"
              data-vv-name="redBalDiscLdg2"
              :data-vv-as="labels.redBalDiscLdg2"
              :error-messages="errors.collect('redBalDiscLdg2')"
              :disabled="enableEdit"
            ></v-autocomplete
          ></v-flex>
          <v-flex xs3
            ><v-autocomplete
              :items="yesnoList"
              v-model="mainForm.prtDiscLdg2"
              :label="labels.prtDiscLdg2"
              item-text="label"
              item-value="value"
              data-vv-name="prtDiscLdg2"
              :data-vv-as="labels.prtDiscLdg2"
              :error-messages="errors.collect('prtDiscLdg2')"
              :disabled="enableEdit"
            ></v-autocomplete
          ></v-flex>
          <v-flex xs3
            ><v-autocomplete
              :items="discLdgCodeList"
              v-model="mainForm.discLdg3Code"
              item-text="label"
              item-value="value"
              :loading="loading"
              @change="doDiscLdg(3)"
              clearable
              :disabled="enableEdit"
            ></v-autocomplete
          ></v-flex>
          <v-flex xs3
            ><v-text-field
              ref="discLdg3Pct"
              v-model="mainForm.discLdg3Pct"
              :label="labels.discLdg3Pct"
              :error-messages="errors.collect('discLdg3Pct')"
              data-vv-name="discLdg3Pct"
              :data-vv-as="labels.discLdg3Pct"
              v-num-mask="{ negative: true, intScale: 18, decScale: 4 }"
              v-validate="valDiscLdg3Pct"
              :disabled="enableEdit"
            ></v-text-field
          ></v-flex>
          <v-flex xs3
            ><v-autocomplete
              :items="yesnoList"
              v-model="mainForm.redBalDiscLdg3"
              :label="labels.redBalDiscLdg3"
              item-text="label"
              item-value="value"
              data-vv-name="redBalDiscLdg3"
              :data-vv-as="labels.redBalDiscLdg3"
              :error-messages="errors.collect('redBalDiscLdg3')"
              :disabled="enableEdit"
            ></v-autocomplete
          ></v-flex>
          <v-flex xs3
            ><v-autocomplete
              :items="yesnoList"
              v-model="mainForm.prtDiscLdg3"
              :label="labels.prtDiscLdg3"
              item-text="label"
              item-value="value"
              data-vv-name="prtDiscLdg3"
              :data-vv-as="labels.prtDiscLdg3"
              :error-messages="errors.collect('prtDiscLdg3')"
              :disabled="enableEdit"
            ></v-autocomplete
          ></v-flex>
          <v-flex xs9></v-flex>
          <v-flex xs3 v-if="!enableEdit">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed @click.prevent="doSave"><span class="btn-normal-primary">Save</span></v-btn>
            </v-card-actions></v-flex
          >
          <!-- <v-flex xs12>
            <table class="v-datatable v-table theme--light">
              <thead>
                <tr>
                  <th role="columnheader" scope="col" aria-sort="none" class="column text-xs-left">{{ labels.discLdgCode }}</th>
                  <th role="columnheader" scope="col" aria-sort="none" class="column text-xs-left">{{ labels.discLdgPct }}</th>
                  <th role="columnheader" scope="col" aria-sort="none" class="column text-xs-left">{{ labels.redBalDiscLdg }}</th>
                  <th role="columnheader" scope="col" aria-sort="none" class="column text-xs-left">{{ labels.prtDiscLdg }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-xs-left">
                    <v-autocomplete
                      :items="discLdgCodeList"
                      v-model="mainForm.discLdg1Code"
                      item-text="label"
                      item-value="value"
                      :loading="loading"
                      @change="doDiscLdg(1)"
                      clearable
                      :disabled="enableEdit"
                    ></v-autocomplete>
                  </td>
                  <td class="text-xs-left">
                    <v-text-field
                      ref="discLdg1Pct"
                      v-model="mainForm.discLdg1Pct"
                      :label="labels.discLdg1Pct"
                      :error-messages="errors.collect('discLdg1Pct')"
                      data-vv-name="discLdg1Pct"
                      :data-vv-as="labels.discLdg1Pct"
                      v-num-mask="{ negative: true, intScale: 18, decScale: 4 }"
                      v-validate="valDiscLdg1Pct"
                      :disabled="enableEdit"
                    ></v-text-field>
                  </td>
                  <td class="text-xs-left"></td>
                  <td class="text-xs-left">
                    <v-autocomplete
                      :items="yesnoList"
                      v-model="mainForm.prtDiscLdg1"
                      :label="labels.prtDiscLdg1"
                      item-text="label"
                      item-value="value"
                      data-vv-name="prtDiscLdg1"
                      :data-vv-as="labels.prtDiscLdg1"
                      :error-messages="errors.collect('prtDiscLdg1')"
                      :disabled="enableEdit"
                    ></v-autocomplete>
                  </td>
                </tr>
                <tr>
                  <td class="text-xs-left">
                    <v-autocomplete
                      :items="discLdgCodeList"
                      v-model="mainForm.discLdg2Code"
                      item-text="label"
                      item-value="value"
                      :loading="loading"
                      @change="doDiscLdg(2)"
                      clearable
                      :disabled="enableEdit"
                    ></v-autocomplete>
                  </td>
                  <td class="text-xs-left">
                    <v-text-field
                      ref="discLdg2Pct"
                      v-model="mainForm.discLdg2Pct"
                      :label="labels.discLdg2Pct"
                      :error-messages="errors.collect('discLdg2Pct')"
                      data-vv-name="discLdg2Pct"
                      :data-vv-as="labels.discLdg2Pct"
                      v-num-mask="{ negative: true, intScale: 18, decScale: 4 }"
                      v-validate="valDiscLdg2Pct"
                      :disabled="enableEdit"
                    ></v-text-field>
                  </td>
                  <td class="text-xs-left">
                    <v-autocomplete
                      :items="yesnoList"
                      v-model="mainForm.redBalDiscLdg2"
                      :label="labels.redBalDiscLdg2"
                      item-text="label"
                      item-value="value"
                      data-vv-name="redBalDiscLdg2"
                      :data-vv-as="labels.redBalDiscLdg2"
                      :error-messages="errors.collect('redBalDiscLdg2')"
                      :disabled="enableEdit"
                    ></v-autocomplete>
                  </td>
                  <td class="text-xs-left">
                    <v-autocomplete
                      :items="yesnoList"
                      v-model="mainForm.prtDiscLdg2"
                      :label="labels.prtDiscLdg2"
                      item-text="label"
                      item-value="value"
                      data-vv-name="prtDiscLdg2"
                      :data-vv-as="labels.prtDiscLdg2"
                      :error-messages="errors.collect('prtDiscLdg2')"
                      :disabled="enableEdit"
                    ></v-autocomplete>
                  </td>
                </tr>
                <tr>
                  <td class="text-xs-left">
                    <v-autocomplete
                      :items="discLdgCodeList"
                      v-model="mainForm.discLdg3Code"
                      item-text="label"
                      item-value="value"
                      :loading="loading"
                      @change="doDiscLdg(3)"
                      clearable
                      :disabled="enableEdit"
                    ></v-autocomplete>
                  </td>
                  <td class="text-xs-left">
                    <v-text-field
                      ref="discLdg3Pct"
                      v-model="mainForm.discLdg3Pct"
                      :label="labels.discLdg3Pct"
                      :error-messages="errors.collect('discLdg3Pct')"
                      data-vv-name="discLdg3Pct"
                      :data-vv-as="labels.discLdg3Pct"
                      v-num-mask="{ negative: true, intScale: 18, decScale: 4 }"
                      v-validate="valDiscLdg3Pct"
                      :disabled="enableEdit"
                    ></v-text-field>
                  </td>
                  <td class="text-xs-left">
                    <v-autocomplete
                      :items="yesnoList"
                      v-model="mainForm.redBalDiscLdg3"
                      :label="labels.redBalDiscLdg3"
                      item-text="label"
                      item-value="value"
                      data-vv-name="redBalDiscLdg3"
                      :data-vv-as="labels.redBalDiscLdg3"
                      :error-messages="errors.collect('redBalDiscLdg3')"
                      :disabled="enableEdit"
                    ></v-autocomplete>
                  </td>
                  <td class="text-xs-left">
                    <v-autocomplete
                      :items="yesnoList"
                      v-model="mainForm.prtDiscLdg3"
                      :label="labels.prtDiscLdg3"
                      item-text="label"
                      item-value="value"
                      data-vv-name="prtDiscLdg3"
                      :data-vv-as="labels.prtDiscLdg3"
                      :error-messages="errors.collect('prtDiscLdg3')"
                      :disabled="enableEdit"
                    ></v-autocomplete>
                  </td>
                </tr>
                <tr v-if="!enableEdit">
                  <td class="text-xs-left"></td>
                  <td class="text-xs-left"></td>
                  <td class="text-xs-left"></td>
                  <td class="text-xs-right">
                    <v-btn class="text-xs-right" depressed @click.prevent="doSave"><span class="btn-normal-primary">Save</span></v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-flex> -->

          <v-dialog v-model="saving" persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                Processing...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { POLICY_COVERAGE } from '@/store/types'
import { removeFormatNumber } from '@/utils/number'
import { isEqual } from '@/utils/compare'
import clone from 'clone'

export default {
  data() {
    return {
      labels: {
        discLdgTitle: 'Discounts / Loadings',
        discLdgCode: 'Code',
        discLdgPct: ' % ', // 'Percentage (%) ',
        redBalDiscLdg: 'Reducing Method',
        prtDiscLdg: 'Print on Schedule'
      },
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        discLdg1Code: undefined,
        discLdg2Code: undefined,
        discLdg3Code: undefined,
        discLdg1Pct: undefined,
        discLdg2Pct: undefined,
        discLdg3Pct: undefined,
        redBalDiscLdg2: undefined,
        redBalDiscLdg3: undefined,
        prtDiscLdg1: undefined,
        prtDiscLdg2: undefined,
        prtDiscLdg3: undefined
      },
      resetForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        discLdg1Code: undefined,
        discLdg2Code: undefined,
        discLdg3Code: undefined,
        discLdg1Pct: undefined,
        discLdg2Pct: undefined,
        discLdg3Pct: undefined,
        redBalDiscLdg2: undefined,
        redBalDiscLdg3: undefined,
        prtDiscLdg1: undefined,
        prtDiscLdg2: undefined,
        prtDiscLdg3: undefined
      },
      polItemForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        discLdg1Pct: undefined,
        discLdg2Pct: undefined,
        discLdg3Pct: undefined,
        emlPct: undefined,
        emlAmt: undefined,
        delItem: undefined,
        formType: 'discLdgForm',
        stdRiskTxtRef: undefined,
        stdItemTxtRef: undefined,
        indGrp: undefined
      },
      polMasterForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        discLdg1Code: undefined,
        discLdg2Code: undefined,
        discLdg3Code: undefined,
        redBalDiscLdg2: undefined,
        redBalDiscLdg3: undefined,
        prtDiscLdg1: undefined,
        prtDiscLdg2: undefined,
        prtDiscLdg3: undefined
      },
      cloneMainForm: {},
      loading: false,
      discLdgCodeList: [],
      yesnoList: [
        {
          label: 'Yes',
          value: true
        },
        {
          label: 'No',
          value: false
        }
      ],
      saving: false,
      enableEdit: true
    }
  },
  props: {
    polItem: Object,
    hideCRUD: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    selectedRiskGrpNo() {
      return this.$store.state.underwriting.policy.selectedRiskGrpNo
    },
    selectedRiskNo() {
      return this.$store.state.underwriting.policy.selectedRiskNo
    },
    getDiscLdg1() {
      return this.discLdgCodeList.filter((discLdg) => {
        return discLdg.value === this.mainForm.discLdg1Code
      })
    },
    getDiscLdg2() {
      return this.discLdgCodeList.filter((discLdg) => {
        return discLdg.value === this.mainForm.discLdg2Code
      })
    },
    getDiscLdg3() {
      return this.discLdgCodeList.filter((discLdg) => {
        return discLdg.value === this.mainForm.discLdg3Code
      })
    },
    valDiscLdg1Pct() {
      if (
        (this.mainForm.discLdg1Code === undefined || this.mainForm.discLdg1Code === null || this.mainForm.discLdg1Code === '') &&
        parseFloat(this.mainForm.discLdg1Pct) > 0
      ) {
        return 'valField:' + 'Must be zero if no Disc/Load code entered. (10095)'
      } else if (
        this.mainForm.discLdg1Code !== undefined &&
        this.mainForm.discLdg1Code !== null &&
        this.mainForm.discLdg1Code !== '' &&
        parseFloat(this.mainForm.discLdg1Pct) === 0
      ) {
        return 'valField:' + 'Zero Discount/Loading %.'
      } else {
        return ''
      }
    },
    valDiscLdg2Pct() {
      if (
        (this.mainForm.discLdg2Code === undefined || this.mainForm.discLdg2Code === null || this.mainForm.discLdg2Code === '') &&
        parseFloat(this.mainForm.discLdg2Pct) > 0
      ) {
        return 'valField:' + 'Must be zero if no Disc/Load code entered. (10095)'
      } else if (
        this.mainForm.discLdg2Code !== undefined &&
        this.mainForm.discLdg2Code !== null &&
        this.mainForm.discLdg2Code !== '' &&
        parseFloat(this.mainForm.discLdg2Pct) === 0
      ) {
        return 'valField:' + 'Zero Discount/Loading %.'
      } else {
        return ''
      }
    },
    valDiscLdg3Pct() {
      if (
        (this.mainForm.discLdg3Code === undefined || this.mainForm.discLdg3Code === null || this.mainForm.discLdg3Code === '') &&
        parseFloat(this.mainForm.discLdg3Pct) > 0
      ) {
        return 'valField:' + 'Must be zero if no Disc/Load code entered. (10095)'
      } else if (
        this.mainForm.discLdg3Code !== undefined &&
        this.mainForm.discLdg3Code !== null &&
        this.mainForm.discLdg3Code !== '' &&
        parseFloat(this.mainForm.discLdg3Pct) === 0
      ) {
        return 'valField:' + 'Zero Discount/Loading %.'
      } else {
        return ''
      }
    }
  },
  methods: {
    setDiscLdgList(discLdgCodeList) {
      if (discLdgCodeList) {
        this.$set(this, 'discLdgCodeList', discLdgCodeList)
      }
    },
    initMainForm() {
      this.mainForm.polNo = this.polItem.polNo
      this.mainForm.renCnt = this.polItem.renCnt
      this.mainForm.endtCnt = this.polItem.endtCnt
      this.mainForm.riskGrpNo = this.polItem.riskGrpNo
      this.mainForm.riskNo = this.polItem.riskNo
      this.mainForm.itemNo = this.polItem.itemNo

      this.mainForm.discLdg1Code = this.polMaster.discLdg1Code
      this.mainForm.discLdg2Code = this.polMaster.discLdg2Code
      this.mainForm.discLdg3Code = this.polMaster.discLdg3Code
      this.mainForm.redBalDiscLdg2 = this.polMaster.redBalDiscLdg2
      this.mainForm.redBalDiscLdg3 = this.polMaster.redBalDiscLdg3
      this.mainForm.prtDiscLdg1 = this.polMaster.prtDiscLdg1
      this.mainForm.prtDiscLdg2 = this.polMaster.prtDiscLdg2
      this.mainForm.prtDiscLdg3 = this.polMaster.prtDiscLdg3

      this.mainForm.discLdg1Pct = this.polItem.discLdg1Pct.toFixed(4)
      this.mainForm.discLdg2Pct = this.polItem.discLdg2Pct.toFixed(4)
      this.mainForm.discLdg3Pct = this.polItem.discLdg3Pct.toFixed(4)

      // this.$refs.discLdg1Pct.$el.cleave.setRawValue(this.mainForm.discLdg1Pct)
      // this.$refs.discLdg2Pct.$el.cleave.setRawValue(this.mainForm.discLdg2Pct)
      // this.$refs.discLdg3Pct.$el.cleave.setRawValue(this.mainForm.discLdg3Pct)

      this.resetForm = clone(this.mainForm)
      this.cloneMainForm = clone(this.mainForm)
    },
    defaultPct() {
      return (0.0).toFixed(4)
    },
    doDiscLdg(data) {
      if (data === 1) {
        if (this.getDiscLdg1.length > 0) {
          if (this.getDiscLdg1[0].secondaryValue === null || this.getDiscLdg1[0].secondaryValue === undefined) {
            this.mainForm.discLdg1Pct = this.defaultPct()
            this.mainForm.discLdg1Pct = this.mainForm.discLdg1Pct.toFixed(4)
          } else {
            this.mainForm.discLdg1Pct = this.getDiscLdg1[0].secondaryValue.toFixed(4)
          }
        } else {
          this.mainForm.discLdg1Pct = this.defaultPct()
        }
      } else if (data === 2) {
        if (this.getDiscLdg2.length > 0) {
          if (this.getDiscLdg2[0].secondaryValue === null || this.getDiscLdg2[0].secondaryValue === undefined) {
            this.mainForm.discLdg2Pct = this.defaultPct()
            this.mainForm.discLdg2Pct = this.mainForm.discLdg2Pct.toFixed(4)
          } else {
            this.mainForm.discLdg2Pct = this.getDiscLdg2[0].secondaryValue.toFixed(4)
          }
        } else {
          this.mainForm.discLdg2Pct = this.defaultPct()
        }
      } else if (data === 3) {
        if (this.getDiscLdg3.length > 0) {
          if (this.getDiscLdg3[0].secondaryValue === null || this.getDiscLdg3[0].secondaryValue === undefined) {
            this.mainForm.discLdg3Pct = 0
            this.mainForm.discLdg3Pct = this.mainForm.discLdg3Pct.toFixed(4)
          } else {
            this.mainForm.discLdg3Pct = this.getDiscLdg3[0].secondaryValue.toFixed(4)
          }
        } else {
          this.mainForm.discLdg3Pct = this.defaultPct()
        }
      }
    },
    doReset() {
      this.mainForm = clone(this.resetForm)
      this.cloneMainForm = clone(this.resetForm)
    },
    review() {
      this.$emit('hidePanel', 'DL')
      this.enableEdit = false
    },
    async doSaveDiscLdg() {
      let output = 'SUCCESS'

      let tempMainForm = {
        discLdg1Pct: this.mainForm.discLdg1Pct,
        discLdg2Pct: this.mainForm.discLdg2Pct,
        discLdg3Pct: this.mainForm.discLdg3Pct,
        redBalDiscLdg2: this.mainForm.redBalDiscLdg2,
        redBalDiscLdg3: this.mainForm.redBalDiscLdg3
      }

      let tempCloneMainForm = {
        discLdg1Pct: this.cloneMainForm.discLdg1Pct,
        discLdg2Pct: this.cloneMainForm.discLdg2Pct,
        discLdg3Pct: this.cloneMainForm.discLdg3Pct,
        redBalDiscLdg2: this.cloneMainForm.redBalDiscLdg2,
        redBalDiscLdg3: this.cloneMainForm.redBalDiscLdg3
      }

      if (isEqual(tempMainForm, tempCloneMainForm)) {
        return 'NOCHANGE'
      }

      this.polItemForm.polNo = this.polMaster.polNo
      this.polItemForm.renCnt = this.polMaster.renCnt
      this.polItemForm.endtCnt = this.polMaster.endtCnt
      this.polItemForm.riskGrpNo = this.mainForm.riskGrpNo
      this.polItemForm.riskNo = this.mainForm.riskNo
      this.polItemForm.itemNo = this.mainForm.itemNo
      this.polItemForm.discLdg1Pct = this.mainForm.discLdg1Pct
      this.polItemForm.discLdg2Pct = this.mainForm.discLdg2Pct
      this.polItemForm.discLdg3Pct = this.mainForm.discLdg3Pct
      this.polItemForm.emlPct = parseInt(removeFormatNumber(this.polItem.emlPct))
      this.polItemForm.emlAmt = removeFormatNumber(this.polItem.emlAmt)
      // AR: Added 15/May OS-150
      this.polItemForm.stdRiskTxtRef = this.polItem.stdRiskTxtRefId
      this.polItemForm.stdItemTxtRef = this.polItem.stdItemTxtRef
      // AR: Added 21/Sep OS-459
      this.polItemForm.delItem = this.polItem.delItem
      // 2021-01-26 LYT OS-646
      this.polItemForm.indGrp = this.polItem.indGrp
      try {
        const result = await this.$store.dispatch('savePolItemRecalcBen', this.polItemForm)
        if (result) {
          output = 'SUCCESS'
        } else {
          output = 'ERROR'
        }
      } catch (err) {
        output = 'ERROR'
      }
      return output
    },
    async doPolMasterSave() {
      let output = 'SUCCESS'

      let tempMainForm = {
        discLdg1Code: this.mainForm.discLdg1Code,
        discLdg2Code: this.mainForm.discLdg2Code,
        discLdg3Code: this.mainForm.discLdg3Code,
        redBalDiscLdg2: this.mainForm.redBalDiscLdg2,
        redBalDiscLdg3: this.mainForm.redBalDiscLdg3,
        prtDiscLdg1: this.mainForm.prtDiscLdg1,
        prtDiscLdg2: this.mainForm.prtDiscLdg2,
        prtDiscLdg3: this.mainForm.prtDiscLdg3
      }

      let tempCloneMainForm = {
        discLdg1Code: this.cloneMainForm.discLdg1Code,
        discLdg2Code: this.cloneMainForm.discLdg2Code,
        discLdg3Code: this.cloneMainForm.discLdg3Code,
        redBalDiscLdg2: this.cloneMainForm.redBalDiscLdg2,
        redBalDiscLdg3: this.cloneMainForm.redBalDiscLdg3,
        prtDiscLdg1: this.cloneMainForm.prtDiscLdg1,
        prtDiscLdg2: this.cloneMainForm.prtDiscLdg2,
        prtDiscLdg3: this.cloneMainForm.prtDiscLdg3
      }

      if (isEqual(tempMainForm, tempCloneMainForm)) {
        return 'NOCHANGE'
      }

      this.saving = true
      this.polMasterForm.polNo = this.polMaster.polNo
      this.polMasterForm.renCnt = this.polMaster.renCnt
      this.polMasterForm.endtCnt = this.polMaster.endtCnt
      this.polMasterForm.discLdg1Code = this.mainForm.discLdg1Code
      this.polMasterForm.discLdg2Code = this.mainForm.discLdg2Code
      this.polMasterForm.discLdg3Code = this.mainForm.discLdg3Code
      this.polMasterForm.redBalDiscLdg2 = this.mainForm.redBalDiscLdg2
      this.polMasterForm.redBalDiscLdg3 = this.mainForm.redBalDiscLdg3
      this.polMasterForm.prtDiscLdg1 = this.mainForm.prtDiscLdg1
      this.polMasterForm.prtDiscLdg2 = this.mainForm.prtDiscLdg2
      this.polMasterForm.prtDiscLdg3 = this.mainForm.prtDiscLdg3

      try {
        this.$store.commit(POLICY_COVERAGE, this.polMasterForm)
        const saveResult = await this.$store.dispatch('savePolicyDiscLdg')
        this.saving = false
        if (saveResult) {
          output = 'SUCCESS'
        } else {
          output = 'ERROR'
        }
      } catch (err) {
        output = 'ERROR'
      }
      this.saving = false
      return output
    },
    // 2021-01-21 LYT OS-642
    async doSave() {
      let output = 'ERROR'
      this.saving = true
      this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.policy.saving = true
      let success = await this.$validator.validateAll()
      if (success) {
        let success1 = await this.doPolMasterSave()
        let success2 = await this.doSaveDiscLdg()
        if (success2 === 'SUCCESS') {
          this.resetForm = clone(this.mainForm)
          this.cloneMainForm = clone(this.mainForm)
          this.$emit('doSave')
        }
        if (success1 === 'ERROR' || success2 === 'ERROR') {
          output = 'ERROR'
        } else if (success1 === 'SUCCESS' || success2 === 'SUCCESS') {
          output = 'SUCCESS'
          this.enableEdit = !this.enableEdit
          this.resetForm = clone(this.mainForm)
          this.cloneMainForm = clone(this.mainForm)
          this.$emit('hidePanel', 'RESET')
        } else {
          output = 'NOCHANGE'
          this.enableEdit = !this.enableEdit
          this.$emit('hidePanel', 'RESET')
        }
      } else {
        output = 'ERROR'
        this.promptFieldCheck()
      }
      this.saving = false
      this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.policy.saving = false
      return output
    }
  },
  created() {
    // Local validator
    const valField = {
      getMessage: (field, args) => {
        if (args === void 0) args = []
        var errMsg = args[0]
        errMsg = errMsg.replace(/%2C/g, ',')
        return errMsg
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var errMsg = args[0]
          if (errMsg) {
            return false
          } else return true
        } else return true
      }
    }
    this.$validator.extend('valField', valField)
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
